const ActivityDetailLoader = ({params})=>  {
    return {
        id: params.id || '',
    };
}

export default ActivityDetailLoader;